import { SORT_BY } from 'hb-react/frontoffice/apps/CommentsV2/constants';
import { QUERY_KEYS } from 'hb-react/frontoffice/apps/CommentsV2/constants/queries';

export const getQueryKey = ({
  commentableId,
  commentableType,
  sortBy = SORT_BY.RECENT,
  isOpenInModal,
  focusedCommentId,
  focusedReplyId,
}: {
  commentableId: number;
  commentableType: string;
  sortBy?: string;
  isOpenInModal?: boolean;
  focusedCommentId?: number;
  focusedReplyId?: number;
}) => [
  QUERY_KEYS.GET_COMMENTS,
  commentableId,
  commentableType,
  sortBy,
  // Comments also rendered when user opens image preview modal on the
  // Live Feed. We DON'T want to synchronize the state between these two
  // comment feeds.
  isOpenInModal,
  focusedCommentId,
  focusedReplyId,
];
